import { render, staticRenderFns } from "./ClinicShowPack.vue?vue&type=template&id=59a65d9b"
import script from "./ClinicShowPack.vue?vue&type=script&lang=js"
export * from "./ClinicShowPack.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowPack.vue?vue&type=style&index=0&id=59a65d9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports